/** 供官员查看的已验证更改清单（第 5 阶段，计划 Task 11）。占位符与 cleanup-changes-en.ts 相同。 */
export default {
  badge: '已用 AI 清理：{{count}} 处更改（其中 {{ai}} 处由 AI 建议）',
  title: '更改了哪些内容',
  loading: '正在核对更改清单…',
  close: '关闭',
  round: '第 {{n}} 轮',
  before: '更改前',
  after: '更改后',
  approvedBy: '由 {{name}} 于 {{date}} 批准',
  proposedByRule: '由 gisify 的规则发现',
  proposedByModel: '由 {{provider}} {{model}} 建议',
  proposedByModelRegion: '由 {{provider}} {{model}} 在 {{region}} 建议',
  reverted: '由 {{name}} 于 {{date}} 撤销',
  unknownPerson: '另一个账户',
  unverified: '无法验证此更改清单，因此不予显示。',
  none: '此更改清单没有记录任何更改。',
  leftOut: '已保存为 AutoCAD 2000',
  listMore: '{{items}}，另有 {{more}} 项',
  yes: '是',
  no: '否',
  op: {
    rename_layer: '重命名了一个图层',
    explode_inserts: '将图块分解为其中的图形',
    scale_units: '将图纸换算为米',
    close_outline: '闭合了缺口小于 1 毫米的轮廓',
    join_pieces: '将首尾相接的线段连接成轮廓',
    show_layer: '打开了一个图层',
    remove_empty_layer: '删除了一个空图层',
    remove_degenerate: '删除了长度为零的图形',
    remove_duplicate: '删除了重复的图形',
    text_to_mtext: '将标注保存为多行文字（文字内容未变）',
    choose_site_boundary: '选定了用地边界',
    assign_layer: '将一个图层归入标准图层',
    assign_shapes: '将图形归入土地用途图层',
    set_units: '设定了绘制图纸所用的单位',
    attach_label: '将一个标注归属到地块',
    label_plot: '为地块指定了土地用途',
    remove_layers: '删除了若干图层',
    remove_entities: '删除了新文件无法保存的对象',
  },
  field: {
    layer: '图层',
    layers: '图层列表',
    count: '数量',
    type: '类型',
    shapes: '图形列表',
    shape: '图形',
    pieces: '线段',
    outlines: '轮廓',
    closed: '已闭合',
    on: '已打开',
    frozen: '已冻结',
    removed: '已删除',
    text: '文字标注',
    plot: '地块',
    moved: '已移动',
    classCode: '土地用途类别',
    candidates: '候选',
    entities: '对象',
    unit: '单位',
    group: '分组',
    insunits: '单位代码',
    factor: '比例系数',
  },
} as const
